module.exports = __webpack_public_path__ + "img/temple_icon.604fee67.png";